import React, { useState } from 'react'
import { connect } from 'react-redux'
import { find } from 'lodash'

import Api from 'services/Api'
import { getUserName, hasAccessToThis } from 'services/Utilities'
import { Alert, Button as MerinioButton, List } from 'ui'
import BaseModal from 'components/Modals/BaseModal'
import ShiftEligibilitySummary from 'components/ContactLists/ShiftEligibilitySummary'
import AllShiftsDeleted from 'Manager/Contact/components/AllShiftsDeleted'
import { closeModal } from 'store/actions/modals'
import { t } from 'translations'

const ContactUserShiftEligibilityModal = ({ id, contactUsers, contactList }) => {
  const [errorSaving, setErrorSaving] = useState(false)
  const { flags: { shiftFlags = {} } = {}, listId, userId } = find(contactUsers, { _id: id })

  const changeEligibility = async (wasEligible, shiftId) => {
    const { success } = await Api.put(`contact/users/${wasEligible ? 'declineShift' : 'approveShift'}`, { _id: id, listId, shiftId })
    setErrorSaving(!success)
  }

  return (
    <BaseModal title={`manager.contactLists.CONTACT_USER_SHIFT_ELIGIBILITY_MODAL`} titleVar={{ name: getUserName(userId) }}>
      <Alert variant="danger" onClose={() => setErrorSaving(false)} show={!!errorSaving}>
        {t('manager.contactLists.CONTACT_USER_SHIFT_ELIGIBILITY_MODAL.ERROR_SAVING_ELIGIBILITY')}
      </Alert>
      <List>
        {contactList.originalShifts.map(shift => {
          const { isEligible } = shiftFlags[shift._id]
          return (
            <ShiftEligibilitySummary
              key={shift._id}
              actionButton={
                hasAccessToThis('contactListControl') ? (
                  <MerinioButton color="secondary" onClick={() => changeEligibility(isEligible, shift._id)} outlined>
                    {t(`manager.contactLists.CONTACT_USER_SHIFT_ELIGIBILITY_MODAL.${isEligible ? 'MAKE_NOT_ELIGIBLE' : 'MAKE_ELIGIBLE'}`)}
                  </MerinioButton>
                ) : null
              }
              shift={shift}
              contactUserId={id}
            />
          )
        })}
        <AllShiftsDeleted originalShifts={contactList.originalShifts} />
      </List>
    </BaseModal>
  )
}

const mapStateToProps = ({ contactLists }) => ({ contactUsers: contactLists.currentContactUsers, contactList: contactLists.currentContactList })
const mapDispatchToProps = dispatch => ({
  closeModal: () => dispatch(closeModal())
})

export default connect(mapStateToProps, mapDispatchToProps)(ContactUserShiftEligibilityModal)
